import { useEffect, useState } from "react";

import SimpleDialog from "components/SimpleDialog";
import { Typography } from "@mui/material";
import PepperChat from 'assets/images/pepper_chat.svg'
import { useRecoilValue, useSetRecoilState } from "recoil";
import { commandsErrorsAtom, tokenAtom } from "lib/globalState";
import { useAuthState } from 'react-firebase-hooks/auth';
import { fireAuth } from "lib/firebase";
import { useHistory } from "react-router";

const Disconnected = () => {
  const [isOpen, setOpen] = useState(false)
  const commandErrors = useRecoilValue(commandsErrorsAtom)
  const setToken = useSetRecoilState(tokenAtom)
  const [opened, setOpened] = useState(false)
  const [user, loading, error] = useAuthState(fireAuth);
  const [prevUser, setPrevUser] = useState(null)
  const history = useHistory()

  const onContinue = async () => {
  }

  const onCancel = () => {
    history.push('/fine')
  }

  useEffect(() => {
    if (prevUser && !user && !opened) {
      setOpen(true)
      setOpened(true)
      setToken(undefined)
    }
    setPrevUser(user)
  }, [user])

  return <SimpleDialog
    open={isOpen}
    title={`Ops! Sei stato disconnesso.`}
    onConfirm={onContinue}
    onCancel={onCancel}
    headerImage={PepperChat}
    cancelLabel="Esci"
    onClose={() => setOpen(false)}
  >
    <Typography>Sei stato disconnesso dal Pepper, ma puoi comunque continuare ad esplorare il sito!</Typography>
  </SimpleDialog>
}

export default Disconnected